import { PRODUCT_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: PRODUCT_MNG,
  relationSearch: true,
  allowStatus: {},
  sortArr: [
    {
      fieldName: 'approvalTime',
      direction: 'DESC'
    }
  ],
  toolbar: {
    searchWidth: 320,
    searchPlaceholder: '请输入产品版本',
    moreBtnWidth: 160,
    searchFieldNameArr: ['productVersion'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: '同步产品版本',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'fetchProductFromYunZhi'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '产品版本',
          prop: 'productVersion',
          sortField: 'productVersion'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '项目立项时间',
          prop: 'approvalTime',
          sortField: 'approvalTime'
        },
        dataType: 'date'
      }
    ]
  }
}
